import React, { useMemo } from 'react';

import { Breadcrumbs } from '@mui/material';

import { useProjectTreeStore } from 'store/projectContract.store';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { BreadcrumbsSeparatorIcon } from 'components/common/Icons/common/BreadcrumbsSeparatorIcon/BreadcrumbsSeparatorIcon';
import { LoaderSpinner } from 'components/common/LodaerSpinner/LoaderSpinner';
import { ProjectTreeNode, findeNodeByUUID } from 'components/common/TreeProgramFilter/ProjectTree/projectTree.utils';

import { ProjectContractFilterButton } from './components/ProjectContractFilterButton/ProjectContractFilterButton';

interface IHeaderBreadcrumbs {
    data: ProjectTreeNode | undefined;
    handleDropdownOpen: ({
        event,
        parent,
    }: {
        event: React.MouseEvent<HTMLElement>;
        parent: ProjectTreeNode | null;
    }) => void;
    isDisabled?: boolean;
}

export const HeaderBreadcrumbs = ({ data, handleDropdownOpen, isDisabled = false }: IHeaderBreadcrumbs) => {
    const { project, contract } = useProjectTreeStore();

    const parent = useMemo(() => {
        return data && project ? findeNodeByUUID(data, project.uuid) : null;
    }, [data, project]);

    return data ? (
        <Breadcrumbs separator={<BreadcrumbsSeparatorIcon />}>
            <ProjectContractFilterButton
                disabled={isDisabled}
                onClick={(event) => !isDisabled && handleDropdownOpen({ event, parent: data })}
                id={'ProjectIdNameResponse_selection'}
                value={project?.title}
                endIcon={<MuiIcon icon={'keyboard_arrow_down'} color={'var(--fg-quaternary)'} />}
                startIcon={<MuiIcon icon={'folder_open'} type={'outlined'} color={'var(--text-primary)'} />}
            />
            <ProjectContractFilterButton
                disabled={isDisabled}
                onClick={(event) => !isDisabled && handleDropdownOpen({ event, parent })}
                id={'ContractTestResponse_selection'}
                value={contract?.title || 'All'}
                endIcon={<MuiIcon icon={'keyboard_arrow_down'} color={'var(--fg-quaternary)'} />}
                startIcon={<MuiIcon icon={'folder_copy'} type={'outlined'} color={'var(--text-primary)'} />}
            />
        </Breadcrumbs>
    ) : (
        <LoaderSpinner />
    );
};
